<template>
  <section class="main-container">
    <div class="columns">
      <div class="column">
        <div class="col1">
          <h3 class="title" v-if="boxId == ''">Crea els detalls de la iniciativa </h3>
          <h3 class="title" v-if="boxId != ''">Edita la iniciativa </h3>
          
          <!-- <h4 class="box-subtitle">Informació bàsica</h4> -->

          <transition name="fade">
            <p v-if="showSuccess" class="has-text-success">Caixa guardada</p>
          </transition>

          <form @submit.prevent style="margin-top:40px">

            <!-- <div class="columns has-margin-bottom-2">
              <div class="column is-one-fifth" v-for="option in boxTypes" v-bind:key="option.id">
                <button @click="setType(option.id)" class="button" v-bind:class="{ 'is-light': box.type != option.id, 'is-primary': box.type == option.id }">
                  {{ option.description }}
                </button>                
              </div>
            </div> -->
            
            <label class="label">Títol de la iniciativa que esteu duent a terme durant el Covid19 de manera solidària</label>
            <input v-model.trim="box.name" type="text" :placeholder="box.name" maxlength="150" id="name" />

            <label class="label">Descripció breu de la iniciativa</label>
            <textarea v-model.trim="box.description" type="text" :placeholder="box.description" maxlength="300" id="zdescription"></textarea>

            <label class="label">Persones o col·lectius a qui reverteix la iniciativa (p.e.: Hospitals, veïnat, col·lectius en risc,...)</label>
            <textarea v-model.trim="box.beneficiaries" type="text" :placeholder="box.beneficiaries" maxlength="1500" id="beneficiaries"></textarea>

            <!-- <label class="label">Recursos que aporta a la comunitat</label>
            <textarea v-model.trim="box.offer" type="text" :placeholder="box.offer" maxlength="2500" id="offer"></textarea> -->

            <label class="label">Suport que soliciteu (p.e.: material, suport econòmic, infraestructura,...). Deixeu aquesta casella en blanc si no voleu rebre cap tipus de suport.</label>
            <textarea v-model.trim="box.demand" type="text" :placeholder="box.demand" maxlength="1500" id="demand"></textarea>

            <label class="label has-margin-bottom-2">On et pot contactar la pesona / entitat que vulgui fer una aportació?</label>

            <label class="label">Email</label>
            <input v-model.trim="box.email" type="text" :placeholder="box.email" maxlength="250" id="email" />

            <label class="label">Web</label>
            <input v-model.trim="box.web" type="text" :placeholder="box.web" maxlength="250" id="web" />

            <label class="label">Telèfon</label>
            <input v-model.trim="box.phone" type="text" :placeholder="box.phone" maxlength="30" id="phone" />

            <label class="label">Whatsapp</label>
            <input v-model.trim="box.whatsapp" type="text" :placeholder="box.whatsapp" maxlength="250" id="whatsapp" />

            <label class="label">Instagram</label>
            <input v-model.trim="box.instagram" type="text" :placeholder="box.instagram" maxlength="250" id="instagram" />

            <label class="label">Twitter</label>
            <input v-model.trim="box.twitter" type="text" :placeholder="box.twitter" maxlength="250" id="twitter" />

            <label class="label">Facebook</label>
            <input v-model.trim="box.facebook" type="text" :placeholder="box.facebook" maxlength="250" id="facebook" />

            <div>
              <label class="label" for="name">A quina comarca es desenvolupa la iniciativa?</label>
              <div class="select zis-primary has-margin-top-1 has-margin-bottom-2" >
                  <select v-model="box.territorial">
                      <option
                      v-for="t in territorials"
                      :value="t.id"
                      v-bind:key="t.id"
                      >{{ t.description }}</option>
                  </select>
              </div>
            </div>



            <label class="label has-margin-bottom-1" for="name">A quina població es desenvolupa la iniciativa?</label>
            <input v-model.trim="box.city" type="text" :placeholder="box.city" id="city" />


            <label class="label">Escull la categoria que s'adigui més a la iniciativa. </label>            
            <div class="columns has-margin-top-2 has-margin-bottom-2 is-multiline">
              <div class="column is-one-quarter" v-for="option in scopes" v-bind:key="option.id">
                <button @click="setScope(option.id)" class="button" v-bind:class="{ 'is-light': box.scope != option.id, 'is-danger': box.scope == option.id }">
                  {{ option.description }}
                </button>                
              </div>
            </div>

            

            

            





            <button
              title=""
                v-if="boxId == ''"
                @click="createBox"
                v-bind:disabled="cantSaveBox"
                class="button is-danger has-margin-top-3 has-margin-bottom-1 has-margin-top-2"
              >Guardar</button>
              
              <button
                v-if="boxId != ''"
                @click="saveBox"
                v-bind:disabled="cantSaveBox"
                class="button is-danger has-margin-top-3 has-margin-bottom-1 has-margin-top-2"
              >Guardar</button>

              <div class="has-text-danger has-margin-bottom-2" v-if="cantSaveBox">
                El títol, la descripció, la comarca i la categoria son camps obligatoris
              </div>            

          </form>

        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import MyBoxes from "@/components/MyBoxes";
import { createNotification } from "../services/notifications.service";
import { levels } from "../services/level.service";
import { scopes } from "../services/scope.service";
import { boxTypes } from "../services/type.service";
import { territorial } from "../services/territorial.service";
const fb = require("../firebaseConfig.js");

export default {
  
  components: {
    MyBoxes
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    cantSaveBox() {
      return this.box.name == '' || this.box.description == '' || this.box.territorial == '' || this.box.scope == '' 
    }   
  },
  data() {
    return {
      boxId: '',
      box: {
        name: "",
        description: "",
        beneficiaries: "",
        offer: "",
        demand: "",        
        scope: "",
        type: "initiative",
        territorial: "",
        city: "",
        phone: "",
        email: "",
        web: "",
        instagram: "",
        facebook: "",
        twitter: "",
        whatsapp: "",
      },
      scopes: scopes,
      showSuccess: false,
      boxTypes: boxTypes,
      territorials: territorial
    };
  },
  mounted() {    
    if (this.$route.params.id) {
      this.boxId = this.$route.params.id;
      this.viewBox();
    }
    else {
      this.boxId = ''
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.id) {
        this.boxId = this.$route.params.id;
        this.viewBox();
      }
      else {
        this.boxId = ''
      }
    }
  },
  methods: {
    viewBox() {
      fb.boxesCollection.doc(this.boxId).get().then(box => {
        this.box = box.data()
        this.box.id = box.id
        this.box.scope = this.box.scope || ''
        this.box.type = this.box.type || ''
        this.$set(this.box, 'territorial', this.box.territorial != null ? this.box.territorial : this.userProfile.territorial)
        this.$set(this.box, 'city', this.box.city != null ? this.box.city : this.userProfile.city)
        
        this.$set(this.box, 'email', this.box.email != null ? this.box.email : '')
        this.$set(this.box, 'web', this.box.web != null ? this.box.web : '')
        this.$set(this.box, 'phone', this.box.phone != null ? this.box.phone : '')
        this.$set(this.box, 'facebook', this.box.facebook != null ? this.box.facebook : '')
        this.$set(this.box, 'twitter', this.box.twitter != null ? this.box.twitter : '')
        this.$set(this.box, 'whatsapp', this.box.whatsapp != null ? this.box.whatsapp : '')
        this.$set(this.box, 'instagram', this.box.instagram != null ? this.box.instagram : '')
        

      })
    },
    createBox() {
      fb.boxesCollection
        .add({
          createdOn: new Date(),
          environment: process.env.BOX_ENV,
          name: this.box.name,
          description: this.box.description,
          beneficiaries: this.box.beneficiaries,
          demand: this.box.demand,
          offer: this.box.offer,
          type: this.box.type,
          scope: this.box.scope,          

          email: this.box.email,
          web: this.box.web,
          phone: this.box.phone,
          facebook: this.box.facebook,
          twitter: this.box.twitter,
          whatsapp: this.box.whatsapp,
          instagram: this.box.instagram,

          userId: this.currentUser.uid,
          city: this.box.city,
          territorial: this.box.territorial,
          user: {
            name: this.userProfile.name,
            email: this.currentUser.email
          },          
          state: "new"
        })
        .then(ref => {
          
          this.boxId = ref.id

          this.$swal('Iniciativa guardada', '', 'success');

          this.$router.push(`/iniciativa/${this.boxId}`)
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveBox() {
      
      fb.boxesCollection.doc(this.boxId).update({
          name: this.box.name,
          description: this.box.description,        
          beneficiaries: this.box.beneficiaries,
          demand: this.box.demand,
          offer: this.box.offer,  
          scope: this.box.scope,
          type: this.box.type,
          city: this.box.city,
          territorial: this.box.territorial,
          email: this.box.email,
          web: this.box.web,
          phone: this.box.phone,
          facebook: this.box.facebook,
          twitter: this.box.twitter,
          whatsapp: this.box.whatsapp,
          instagram: this.box.instagram,
      })
      .then(box => {

        let msg = ''       
        this.$swal('Iniciativa guardada', msg, 'success');

        this.$router.push(`/iniciativa/${this.boxId}`)

        // this.showSuccess = true
        // setTimeout(() => {
        //     this.showSuccess = false;
        //   }, 2000);
      })
    },
    onUploaded(info) {
      console.log('info', info)
      //this.$emit('file-uploaded', { })
      this.update = !this.update;
    },
    setScope(scope) {
      this.box.scope = scope
      let scopeItem = this.scopes.find(s => s.id == scope)
      if (scopeItem && scopeItem.dimensions) {
        this.dimensions = scopeItem.dimensions
      }
      else {
        this.dimensions = []
        this.box.dimension = ''
      }
      this.getDimensions()
    },
    setScope(scope) {
      this.box.scope = scope      
    },
    setType(t) {
      this.box.type = t
    },  
    setLevel(level) {
      this.box.level = level
    },
    addLink() {
      this.box.links.push(this.newLink)
      this.newLink = ''
    },
    viewLink(link) {
      window.open(link)      
    },
    deleteLink(link, index) {
      this.box.links.splice(index, 1)
    },
    getDimensions() {
      let scopeItem = this.scopes.find(s => s.id == this.box.scope)
      if (scopeItem && scopeItem.dimensions) {
        this.dimensions = scopeItem.dimensions
      }
      else {
        this.dimensions = []
        this.competences = []
        this.box.dimension = ''
      }
      this.getCompetences()
    },
    getCompetences() {
      if (this.dimensions && this.box.dimension && this.box.dimension != '') {
        let dimensionItem = this.dimensions.find(d => d.id == this.box.dimension)
        if (dimensionItem && dimensionItem.competences) {
          this.competences = dimensionItem.competences
        }
        else {
          this.competences = []
          this.box.competences = []
        }
      }
      else {
          this.competences = []
          this.box.competences = []
        }
    },
    hasCompetence(c) {
      return this.box.competences.indexOf(c) >= 0
    }
  },  
  filters: {
    stateText(val) {
      if (val == 'new') {
        return 'NOVA'
      }
      else if (val == 'active') {
        return 'ACTIVA'
      }
      else if (val == 'draft') {
        return 'ESBORRANY'
      }
      else if (val == 'deleted') {
        return 'ESBORRADA'
      }
      return val
    }
  }
};
</script>

<style scoped>
textarea#description{
  height: 250px;
}
.buttons-column{
  position: fixed;
  top:80px
}
input, textarea{
  background-color: #f1f1f1;
}

</style>


// WEBPACK FOOTER //
// src/components/BoxEdit.vue